import * as React from 'react';
import { Trans } from './Trans';

export interface LoadingProps {
}

export class Loading extends React.Component<LoadingProps> {
    public render() {
        return <div className="jc-loading">
            <div className="jc-loading-inner">
                <h2><Trans>Daten werden geladen</Trans></h2>
                <i className="fas fa-circle-notch fa-spin"/>
            </div>
        </div>;
    }
}
